
import axios from 'axios'
import Divider from 'vux/src/components/divider/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import Bus from '../bus'
import AddSubmit from './AddSubmit'
export default {
name:'VehicleResource',
components:{
Divider,
AddSubmit,
Loading
},
props:['imgList','hasAuth','showmodal4'],
data () {
return {
list:[],
pageNum:0,
isLoading:false,
loadingText:'',
positionimg2:require('../assets/2.png'),
systemId:''
}
},
methods:{
getOtherList (pageNum = 0) {
const _this = this;
var data = {
pageNum: pageNum,
pageSize: 10,
type:3,
systemId:this.systemId
}
if (this.hasAuth) {
data.auth = 1
}
this.isLoading = true
this.loadingText = "加载中..."
axios.post("/yuncai-yop/contribute/page", data).then(function (res) {
if (res.status == 200) {
let list = res.data.data.list || []
_this.list = _this.list.concat(list)
if (res.data.data.nextPage > 0) {
_this.pageNum = res.data.data.nextPage - 1
} else {
_this.pageNum = 0
}
}
_this.isLoading = false
}).catch(function (err) {
_this.isLoading = false
console.log(err)
})
},
},
mounted(){
var tag = window.location.search.split('=')[1]
if(tag && tag.includes('hzh')){

this.systemId = 1
}else{

this.systemId = 0
}
this.getOtherList()
}
}



// WEBPACK FOOTER //
// ./src/components/VehicleResource.vue